<h2 mat-dialog-title>Escolha seu especialista</h2>
<mat-dialog-content class="mat-typography">   
    <p class="initial-p">Veja abaixo os especialistas disponíveis:</p>

    <h2 class="text-center not-found" *ngIf="!loading && healthcareservices.length == 0">Não há especialistas disponíveis no momento</h2>

    <div *ngFor="let healthcareservice of healthcareservices; index as i">
      
        <schedule-specialist-card
            [practitioner]="selectPractitioner(healthcareservice.practitioner_id)"
            [location]="location"
            [index]="i"
            [healthcareservicesSpecialist]="healthcareservice"
            [practitionerRole]="selectPractitionerRole(healthcareservice.practitioner_id)"
            [actor]="actor"
        >
        </schedule-specialist-card>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
          <button mat-button  color="primary" [mat-dialog-close]="false">Fechar</button>          
</mat-dialog-actions>
